<template>
  <not-found-view v-if="$route.name === '404'"/>
  <home-view v-else/>
</template>

<script lang="ts">

import HomeView from './views/HomeView.vue'
import NotFoundView from './views/NotFoundView.vue'

export default({
  components: {
    HomeView, NotFoundView
  }
})
</script>

<style>

#app {
  height: 100vh;
  width: 100vw;
}

@font-face {
font-family: 'Menlo Regular';
font-style: normal;
font-weight: normal;
src: local('Menlo Regular'), url('/public/font/menlo-regular.woff') format('woff');
}

*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
}

*::-webkit-scrollbar {
  width: .3rem;
  height: .3rem;
}

*::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 100px;
  /* margin: 1rem 0; */
}

*::-webkit-scrollbar-thumb {
  background-color: #cecece;
  border-radius: 100px;
}

:root {
  --background_color: #eeeeee;
  --red: #ff4d4d;
  --font_color: #2c3e50;
  font-size: 18px;
}

body {
  font-family: 'Menlo Regular';
  font-display: optional;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: normal;
  color: var(--font_color);
  background-color: var(--background_color);

  text-decoration: none;
  margin: 0;
  padding: 0;
  border: none;

  overflow: hidden;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /* убирает моргание при нажатии на ссылку в mobile */

  scroll-behavior: smooth;

  /* -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    word-wrap: break-word; */
}

@media screen and (max-width: 1150px) {
  :root {
    font-size: 14px
  }
}

a {
  cursor: pointer;
  color: var(--font_color);
  text-decoration: none;
}


/* =========== */
/* Transitions */
/* =========== */

.fade-enter-active {
  transition: all 1.2s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.fade-leave-active {
  transition: all .7s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.fade-move {
  transition: transform 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
